<template>
  <div class="relative"
       v-on-clickaway="hide">
    <input class="form-input w-full"
           autocomplete="off"
           type="text"
           ref="input"
           :class="{ 'error': error }"
           :name="name"
           v-model="search"
           @focus="show"
           v-bind="$attrs"
           @keydown.down.prevent="down"
           @keydown.up.prevent="up"
           @keydown.enter.prevent="enter"
           @keydown.esc.prevent="escape"
           @blur="blur">
    <div class="form-error"
         v-if="error">{{ error }}</div>
    <div class="absolute bg-white w-full shadow py-2 z-20 overflow-y-auto mb-5"
         ref="menu"
         v-if="showMenu">
      <div class="flex justify-between px-4 py-2 hover:bg-blue-100 cursor-pointer group"
           :class="{ 'bg-blue-100 hover:bg-blue-200': activeIndex == index }"
           v-for="(row, index) in limitedResults"
           :key="row.id"
           @click.prevent="select(row)">
        <slot v-bind:row="row"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from "@/api.js";
import { mixin as clickaway } from "vue-clickaway";

export default {
  inheritAttrs: false,

  mixins: [clickaway],

  model: {
    prop: "value",
    event: "select"
  },

  props: {
    url: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    error: {
      type: [String, Boolean],
      default: false
    }
  },

  data() {
    return {
      hasFocus: false,
      search: "",
      results: [],
      selected: null,
      activeIndex: -1
    };
  },

  computed: {
    limitedResults() {
      return this.results.slice(0, 5);
    },

    showMenu() {
      return this.search && this.results.length && this.hasFocus;
    }
  },

  watch: {
    search() {
      if (this.search) {
        this.hasFocus = true;
        get(this.url, { query: this.search }).then(
          response => (this.results = response.data)
        );
      } else {
        this.search = [];
      }
    }
  },

  methods: {
    clear() {
      this.selected = null;
      this.$emit("select", null);
      this.$nextTick(() => this.$refs.input.focus());
    },

    select(row) {
      this.selected = row;
      this.hasFocus = false;
      this.$emit("select", row);
    },

    show() {
      this.hasFocus = true;
    },

    hide() {
      this.hasFocus = false;
    },

    down() {
      this.activeIndex += 1;

      if (this.activeIndex >= this.limitedResults.length) {
        this.activeIndex = -1;
      }
    },

    up() {
      this.activeIndex -= 1;

      if (this.activeIndex < -1) {
        this.activeIndex = this.limitedResults.length - 1;
      }
    },

    enter() {
      if (this.results[this.activeIndex]) {
        this.select(this.results[this.activeIndex]);
      }
    },

    blur() {
      this.activeIndex = -1;
    }
  }
};
</script>
